import { apiGet } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/billing/charge', query).then(result => result.response);
  },
};
